import { Component, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MarketingEmailComponent } from './marketing-email/marketing-email.component';
@Component({
  selector: 'app-send-notification',
  imports: [MarketingEmailComponent, TranslateModule],
  templateUrl: './send-notification.component.html'
})
export class SendNotificationComponent {

  activeTab = signal('marketing-email');
}
